import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { IApiStatus } from '@common/models/IApiStatus';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(private apiService: ApiService) { }
  get(mnemonic, activityType, name): Observable<any> {
    return this.apiService.get(`Note/${mnemonic}/${activityType}/${name}`);
  }
  add(requestBody): Observable<any>{
    return this.apiService.post(`Note`, requestBody);
  }
  save(requestBody): Observable<any>{
    return this.apiService.put(`Note`, requestBody);
  }
  delete(comment): Observable<IApiStatus> {
    return this.apiService.delete(`Note/${comment._id}`)
  }
}
